<button
    *ngFor="let assignment of assignments$ | async; let index = index"
    [class.active]="selectedAssignment && selectedAssignment === assignment.effectiveDate"
    (click)="handleClick(assignment)"
>
    <span>{{ assignment.effectiveDate | date }}:</span>
    <strong>{{ assignment.profileHierarchy ? assignment.profileHierarchy : assignment.profile }}</strong>
</button>
